import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
// import * as $ from 'jquery';
import { timeout } from 'q';
import { ToastrService } from 'ngx-toastr';
import { HomeService } from '../services/home.service';

import { Maps } from '../../assets/mapModel'

declare var google: any;
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  logintype: string = localStorage.getItem('usertype')
  sessionStoreURL = localStorage.getItem('sesssionUrl')
  isBanner = sessionStorage.getItem('banner')
  //advancedSearch: boolean = false
  advancedCity: string = ''
  homePageData: any = {}
  cities: any = []
  token: string

  slideConfig = {
    infinite: true,
    speed: 300,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 760,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    ]

  };

  slideConfigSpe = {
    infinite: true,
    speed: 300,
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    ]

  };

  @ViewChild("placesRef1") placesRef: GooglePlaceDirective;
  options = {
    types: [],
    componentRestrictions: { country: 'in' }
  }

  bookObject: any = {
    address: '',
    lat: '',
    lng: '',
    phoneNo: ''
  }
  otpBookingServer: any = {
    otp: 0,

  }
  otpValObj1_booking: string
  otpValObj2_booking: string
  otpValObj3_booking: string
  otpValObj4_booking: string
  //phoneNo:Number
  isLoggedIn: boolean = !!localStorage.getItem('token')
  verifyOtpError_Booking: boolean = false
  errorOtpBooking_user: boolean = false
  showbooking_pass_user: boolean = false
  showbookingotp_user_login: boolean = false
  showEyeUserBooking: boolean = true
  Pass_userBooking: string = ''
  verifyPassError_userBooking: boolean = false
  errorOtpUserBookingMessage: any = ''

  flag2 = true

  coordinates: any = {};

  // map keys
  map: any = {};
  marker: any = {};
  mapKeys = Maps;
  imageUrlArray: any = []
  banners: any = []

  constructor(private auth: AuthService,
    public homeSvc: HomeService, public router: Router,
    private toaster: ToastrService ) {


    if (this.sessionStoreURL && this.isLoggedIn) {
      this.router.navigate([`/${this.sessionStoreURL}`])
    }

    this.auth.getMapData().subscribe(res => {
      let checkData = res['data'];
      if (checkData.length) {
        localStorage.setItem('ambulanceBook', '1')
        this.router.navigate(['/ambulance-tracking'])
      }
    });

    this.auth.isLoggedinForHome.subscribe(data => {

      this.isLoggedIn = data
      // if (data)
      //  this.bookObject['phoneNo'] = JSON.parse(localStorage.getItem('logindata'))['phoneNo']

    })
    // this.changeDetect.detectChanges()
  }


  ngOnInit() {
    this.getHomePageData();
    this.getBanner();
    this.listSpecialities();
    this.auth.getLocation().then(location => {
      if (!location.nolocation) {
        this.bookObject['lng'] = location.lng

        this.bookObject['lat'] = location.lat
        console.log(this.bookObject)

      } else {
        this.bookObject['lng'] = 76.7794
        this.bookObject['lat'] = 30.7333
      }

      this.initializeMap()

    })

    this.isLoggedIn = this.auth.isLoggedin

    if (this.isLoggedIn)
      this.bookObject['phoneNo'] = JSON.parse(localStorage.getItem('logindata'))["phoneNo"]



  }

  contactNo: any = {};

  getBanner() {
    if (!this.isBanner) {
      this.homeSvc.getBanners().subscribe(res => {
        this.banners = res["data"].banner;
        this.contactNo = res["data"].contactNo;
        // const self = this;
        // setTimeout(function () {
        //   self.loadBanner();
        // }, 1);
      })
    }
  }
  gotoDetail(banner) {
    if (banner.type == 'DOCTOR')
      this.router.navigate(['/doctors/detail/' + banner.doctorId]);
    else if (banner.type == 'LAB')
      this.router.navigate(['/labs/detail/' + banner.labId]);
    else if (banner.type == 'HOSPITAL')
      this.router.navigate(['/hospitals/detail/' + banner.hospitalId]);
    else if (banner.type == 'CHAT') {
      sessionStorage.setItem('chat-bot', '1');
      this.router.navigate(['/telemedicine']);
    } else if (banner.type == 'PHARMECY') {
      this.router.navigate(['/pharmacy/detail/' + banner.pharmecyId]);
    } else if (banner.type == 'DAKTARZ_PAGE_3') {
      this.router.navigate(['/page/INFO']);
    }
  }

  initializeMap() {
    var latlng = new google.maps.LatLng(this.bookObject['lat'], this.bookObject['lng']);
    var myOptions = {
      zoom: this.mapKeys.zoomModal,
      center: latlng,
      // styles: this.mapKeys.style,
      streetViewControl: false,
      disableDefaultUI: false,
      mapTypeControl: false,
      gestureHandling: "greedy"
    };
    this.map = new google.maps.Map(document.getElementById("mapLocation"), myOptions);
    this.map.setCenter(latlng);
    this.getLocation();
    //const self = this;
    this.map.addListener('center_changed', () => {
      this.getLocation();
    });


  }

  getLocation() {
    console.log('yes')


    this.bookObject["lat"] = this.bookObject['lat']
    this.bookObject["lng"] = this.bookObject['lng']
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({
      'latLng': this.map.getCenter()
    }, (results, status) => {
      if (status == google.maps.GeocoderStatus.OK) {
        if (!!results && results.length) {
          results[0].address_components.map(function (addr) {
            if (addr.types[0] == 'locality' && addr.types[1] == 'political') {
              localStorage.setItem('currentcity', addr.long_name)

            }
          });
          // console.log('results[0].formatted_address', results[0])
          this.bookObject["address"] = results[0].formatted_address;
        }
      }
    });
  }

  gotoDoctorList() {
    localStorage.setItem('doctorFilterCity', this.advancedCity)
    this.router.navigate(['/doctors/list'])
  }

  openTourism() {
    this.auth.changeMessage()
  }

  getHomePageData() {
    this.homeSvc.getHomePageData().subscribe(res => {
      console.log(res)
      this.homePageData = res["data"]
    }, error => {
    })


    this.homeSvc.getCities('DOCTOR').subscribe(res => {
      this.cities = res["data"]
    }, error => {

    })

  }


  tabChanged() {
    this.flag2 = false;
    setTimeout(() => {
      this.flag2 = true
      $('.slick-next .slick-arrow').click()
    }, 150)
  }

  handleAddressChange(address: Address) {

    var latlng = new google.maps.LatLng(address.geometry.location.lat(), address.geometry.location.lng());
    this.map.setCenter(latlng);

    this.bookObject["lat"] = address.geometry.location.lat()
    this.bookObject["lng"] = address.geometry.location.lng()
    this.bookObject["address"] = address.formatted_address
    localStorage.setItem('currentaddress', address.formatted_address);
  }


  getCurrentLocation() {
    // if(!this.isLoggedIn){
    //   this.bookObject['name'] = ''
    //   this.bookObject['phoneNo'] = ''
    // }
    // this.bookObject['name'] = '';
    this.bookObject['phoneNo'] = localStorage.getItem('phoneNo');
    this.auth.getLocation().then(location => {
      if (!location.nolocation) {
        this.bookObject['lat'] = location.lat
        this.bookObject['lng'] = location.lng


      }
      else {
        this.bookObject['lng'] = 76.7794
        this.bookObject['lat'] = 30.7333
      }
      this.initializeMap()



      console.log(this.bookObject)


    })
    document.getElementById('emergency_trigger').click()
    //this.bookObject['address'] = localStorage.getItem('currentaddress');
  }
  back() {
    document.getElementById('booking_otp_trigger').click()
    document.getElementById('emergency_trigger').click()
  }
  forgotPassUser() {
    this.auth.forgotPassUser(this.bookObject.phoneNo, '+91').subscribe(res => {
      this.toaster.success('Please check your phone for Password...', '', {
        timeOut: 2000
      });
    }, error => {
      this.toaster.success('There was some error sending the password...', '', {
        timeOut: 2000
      });
    })
  }
  checkPassfunc_userBooking() {
    this.auth.checkPassfunc_user(this.bookObject.phoneNo, this.Pass_userBooking, 'User').subscribe(res => {
      console.log(res)
      if (res == 'Success') {
        this.verifyPassError_userBooking = false
        // this.showbooking_pass_user = false
        this.bookAmbulance(false)
        // document.getElementById("booking_otp_trigger").click();
        this.auth.isLoggedin = true
        this.toaster.success('Succesfully logged In...', '', {
          timeOut: 2000
        });
        // $(document.body).addClass("modal-open");
        //this.loginData = JSON.parse(localStorage.getItem('logindata'))
        //     localStorage.setItem('sesssionUrl', `/${this.type}/profile-edit`)


      }
    }, error => {
      console.log(error)
      this.verifyPassError_userBooking = true
    })

  }

  bookAmbulance_without_login() {
    if (this.auth.isLoggedin) {
      this.bookAmbulance(true)
    }
    else {
      if (this.bookObject.phoneNo) {
        let len = this.bookObject.phoneNo.toString();

        console.log(len.length, 'this.bookObject.phoneNo.length');

        if (len.length <= 15 && len.length >= 6) {
          this.auth.getOtp(this.bookObject["phoneNo"], 'User').subscribe((res: any) => {
            console.log(res);
            if (res.statusCode == 200) {
              this.otpBookingServer = res.data;


              document.getElementById('emergency_trigger').click();
              document.getElementById('booking_otp_trigger').click();
              this.bookObject.phoneNo = localStorage.getItem('phoneNo') ? localStorage.getItem('phoneNo') : this.bookObject.phoneNo;


              if (this.otpBookingServer.otp == 1) {
                console.log(this.otpBookingServer.otp)
                this.showbooking_pass_user = true
                this.showbookingotp_user_login = false

              }
              else {
                this.showbookingotp_user_login = true
                this.errorOtpBooking_user = false
                this.showbooking_pass_user = false

              }


            }

            //this.router.navigate(['/ambulance-tracking'])
          },
            error => {
              console.log(error);
              this.errorOtpUserBookingMessage = error.error.message
            })
        } else {
          this.toaster.error('Contact number length should be 6-16 characters', 'Error', {
            timeOut: 2000
          });
        }
      } else {
        this.toaster.error('Please enter contact number', 'Error', {
          timeOut: 2000
        });
      }
    }

  }

  checkOtpfuncUserBookingLogin() {
    // debugger
    let otp_val = this.otpValObj1_booking + '' + this.otpValObj2_booking + '' + this.otpValObj3_booking + '' + this.otpValObj4_booking
    console.log(this.bookObject.phoneNo)
    this.auth.checkOtpfunc(this.bookObject.phoneNo, otp_val, 'User').subscribe(res => {
      console.log(res)
      if (res == 'Success') {
        this.verifyOtpError_Booking = false
        this.bookAmbulance(false)
        this.bookObject.phoneNo = localStorage.getItem('phoneNo') ? localStorage.getItem('phoneNo') : this.bookObject.phoneNo

      }
      // route to profile and result already stored in auth service in localstorage
    }, error => {
      console.log(error)
      this.verifyOtpError_Booking = true
      localStorage.clear()
    })
  }

  resendOtp() {

    this.auth.getOtp(this.bookObject["phoneNo"], 'User').subscribe((res: any) => {
      if (res.statusCode == 200) {
        this.otpBookingServer.otp = res.data.otp
        this.toaster.success('Otp Sent....', 'Success', {
          timeOut: 2000
        });
      } else {
        this.toaster.error('There was some Error sending the Otp...', 'Error', {
          timeOut: 2000
        });
      }
    },
    error => {
      this.toaster.error('There was some Error sending the Otp...', 'Error', {
        timeOut: 2000
      });
      console.log(error);
    });
  }

  bookAmbulance(flag: boolean) {
    console.log(this.bookObject)
    this.auth.bookAmbulance(this.bookObject).subscribe((res1: any) => {

      if (res1.statusCode == 200) {
        localStorage.setItem('ambulanceId', res1.data.ambulanceId)

        // document.getElementById('loginEmergency').click()
        if (!flag) {

          this.isLoggedIn = true
          this.auth.isLoggedin = true
          document.getElementById('booking_otp_trigger').click()
        } else {
          document.getElementById('emergency_trigger').click()
        }
        localStorage.setItem('ambulanceBook', '1')
        this.router.navigate(['/ambulance-tracking'])
      }
    }, error => {
      //console.log(error)
      this.toaster.error(error.error.message, 'Error', {
        timeOut: 2000
      });

    })
  }

  numberOnly(event, id): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    if (id != null)
      document.getElementById(id).focus();
    return true;
  }

  counter(i: number) {
    return new Array(i);
  }

  parseInt(number) {
    return parseInt(number)
  }
  testEvent(index) {
    console.log(index)
  }

  loadBanner() {
    $('.slider123').slick({
      infinite: false,
      dots: false,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      ]
    });
  }

  allSpecialities = [];

  listSpecialities() {
    this.auth.listSpecialities().subscribe((res1: any) => {

      if (res1.statusCode == 200) {
        this.allSpecialities = res1.data.reverse();
      }
    }, error => {
      //console.log(error)
      this.toaster.error(error.error.message, 'Error', {
        timeOut: 2000
      });
    })
  }

  goToDoctorListData(data) {
    if(data.keywords && data.keywords.length) {
      this.router.navigate(['/doctors/list'], { queryParams: {speciality: data.keywords[0]} });
    }
  }

}
